import React from "react";
import methodModel from "../../../methods/methods";
import { FiPlus } from "react-icons/fi";
import ImageHtml from "../ImageHtml";

const Html = ({
  type,
  inputElement,
  uploadImage,
  img,
  className = "",
  remove,
  loader,
  model,
  multiple,
  required,
  err,
  accept,
  label,
  progress,
  fallback
}) => {
  return (
    <>
      <label
        className={`block cursor-pointer text-gray-500 bg-white border-2 border-dashed border-[#540C0F] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-8 py-4 text-center ${img && !multiple ? "d-none" : ""
          }`}
      >
        <input
          type="file"
          className="hidden"
          ref={inputElement}
          accept={accept}
          multiple={multiple ? true : false}
          disabled={loader}
          onChange={(e) => {
            uploadImage(e);
          }}
        />
        <div className="flex flex-col items-center justify-center">
          <FiPlus className="text-2xl text-[#540C0F]" />
          <span>{label || "Please upload images"}</span>
        </div>
      </label>

      {loader ? <>

        <div className="flex gap-2 items-center mt-4">


          <div className="w-full   bg-gray-200 rounded-full h-3">
            <div className={`bg-primary h-3 rounded-full w-[${progress}%]`}></div>

          </div>
          <p className="">   {progress}%</p>
        </div>
      </> : <></>}

      {/* {loader ? (
        <div className="text-success text-center mt-2">
          Uploading... <i className="fa fa-spinner fa-spin"></i>
        </div>
      ) : (
        <></>
      )} */}

      {multiple ? (
        <>
          <div className="imagesRow">
            {img &&
              img.map((itm, i) => {
                return (
                  <div className="imagethumbWrapper bg-[#b7b7b7] p-3 rounded-[6px] ">
                    <img
                      src={type == 'image' ? methodModel.noImg(itm, model) : '/assets/img/doc.png'}
                      className="w-[140px] "
                    />
                    <i
                      className="fa fa-times"
                      title="Remove"
                      onClick={(e) => remove(i)}
                    ></i>
                  </div>
                );
              })}
          </div>
        </>
      ) : (
        <>
          {img ? (
            <div className="imagethumbWrapper">
              <ImageHtml errSrc={fallback ? fallback : "/assets/img/person.jpg"} src={type == 'image' ? methodModel.noImg(img, model) : '/assets/img/doc.png'} className={`thumbnail ${className} `} alt="" />
              <i
                className="fa fa-times"
                title="Remove"
                onClick={(e) => remove()}
              ></i>
            </div>
          ) : (
            <></>
          )}
        </>
      )}

      {required && !img ? (
        <div className="text-danger">{err ? err : "Image is Required"}</div>
      ) : (
        <></>
      )}
    </>
  );
};
export default Html;
